import QRCode from 'qrcode';
var APK_CONFIG_URL = '/app/download/latest.json';
var APK_PATH_PREFIX = '/app/download/';
var APK_CONFIG_CACHE_KEY = 'tiklive-apk-url';
export default {
  name: 'usIndexmaterialContent',
  components: {},
  data: function data() {
    return {
      apkDownloadUrl: '',
      qrcodeImage: ''
    };
  },
  mounted: function mounted() {
    this.initApkQRCode();
  },
  methods: {
    /**
     * 初始化 APK 下载地址并生成二维码。
     * @returns {void}
     */
    initApkQRCode: function initApkQRCode() {
      var _this = this;
      var cachedApkUrl = this.getCachedApkUrl();
      if (cachedApkUrl) {
        this.updateApkQRCode(cachedApkUrl);
        return;
      }
      this.fetchApkConfig(function (apkUrl) {
        _this.cacheApkUrl(apkUrl);
        _this.updateApkQRCode(apkUrl);
      });
    },
    /**
     * 使用 APK 相对路径更新下载地址和二维码。
     * @param {string} apkUrl S3 配置返回的 APK 相对路径
     * @returns {void}
     */
    updateApkQRCode: function updateApkQRCode(apkUrl) {
      var downloadUrl = this.createAbsoluteApkUrl(apkUrl);
      if (!downloadUrl) {
        return;
      }
      this.apkDownloadUrl = downloadUrl;
      this.createQRCodeImage(downloadUrl);
    },
    /**
     * 读取 S3 上固定路径的 APK 配置文件。
     * @param {Function} callback 获取合法 APK 地址后的回调函数
     * @returns {void}
     */
    fetchApkConfig: function fetchApkConfig(callback) {
      var _this2 = this;
      var xhr = new XMLHttpRequest();
      var requestUrl = "".concat(APK_CONFIG_URL, "?t=").concat(Date.now());
      xhr.open('GET', requestUrl, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status < 200 || xhr.status >= 300) {
          console.warn('APK配置读取失败');
          return;
        }
        var config = {};
        try {
          config = JSON.parse(xhr.responseText);
        } catch (error) {
          console.warn('APK配置解析失败', error);
          return;
        }
        if (!_this2.isValidApkUrl(config.apkUrl)) {
          console.warn('APK下载地址不合法');
          return;
        }
        callback(config.apkUrl.trim());
      };
      xhr.send(null);
    },
    /**
     * 读取当前标签页缓存的 APK 下载地址。
     * @returns {string} 合法 APK 相对路径
     */
    getCachedApkUrl: function getCachedApkUrl() {
      try {
        var cachedApkUrl = window.sessionStorage.getItem(APK_CONFIG_CACHE_KEY);
        return this.isValidApkUrl(cachedApkUrl) ? cachedApkUrl.trim() : '';
      } catch (error) {
        console.warn('APK缓存读取失败', error);
        return '';
      }
    },
    /**
     * 缓存 APK 下载地址，避免当前标签页重复请求配置。
     * @param {string} apkUrl S3 配置返回的 APK 相对路径
     * @returns {void}
     */
    cacheApkUrl: function cacheApkUrl(apkUrl) {
      try {
        window.sessionStorage.setItem(APK_CONFIG_CACHE_KEY, apkUrl.trim());
      } catch (error) {
        console.warn('APK缓存写入失败', error);
      }
    },
    /**
     * 校验 APK 下载地址是否在官网下载目录下。
     * @param {string} apkUrl S3 配置返回的 APK 相对路径
     * @returns {boolean} 是否为合法 APK 下载路径
     */
    isValidApkUrl: function isValidApkUrl(apkUrl) {
      return typeof apkUrl === 'string' && apkUrl.trim().indexOf(APK_PATH_PREFIX) === 0;
    },
    /**
     * 按当前官网域名拼接 APK 完整下载地址。
     * @param {string} apkUrl S3 配置返回的 APK 相对路径
     * @returns {string} APK 完整下载地址
     */
    createAbsoluteApkUrl: function createAbsoluteApkUrl(apkUrl) {
      if (!this.isValidApkUrl(apkUrl)) {
        return '';
      }
      return "".concat(window.location.protocol, "//").concat(window.location.host).concat(apkUrl.trim());
    },
    /**
     * 根据 APK 下载地址生成二维码图片。
     * @param {string} downloadUrl APK 完整下载地址
     * @returns {void}
     */
    createQRCodeImage: function createQRCodeImage(downloadUrl) {
      var _this3 = this;
      QRCode.toDataURL(downloadUrl, {
        errorCorrectionLevel: 'H',
        quality: 0.3,
        margin: 0,
        color: {
          dark: '#333'
        }
      }, function (error, image) {
        if (error) {
          console.warn('APK二维码生成失败', error);
          return;
        }
        _this3.qrcodeImage = image;
      });
    },
    /**
     * 二维码未生成前阻止空链接跳转。
     * @param {Event} event 点击事件对象
     * @returns {void}
     */
    handleQRCodeClick: function handleQRCodeClick(event) {
      if (!this.apkDownloadUrl) {
        event.preventDefault();
      }
    }
  }
};